import { UserRole } from '@api/models/enums/UserRole';
import { useAppSelector } from '../../../store';
import { selectIdentity } from '../../../store/entities/identity';
import { hasRole } from '../../../utils/roles';

const CHANGE_HISTORY_ROLES = [UserRole.ManagerOsah, UserRole.AdminCompany, UserRole.AdminQcs];

/** The change history shows who changed what, so only the roles that manage the company's data see it. */
export const useCanSeeChangeHistory = () => hasRole(useAppSelector(selectIdentity).roles, CHANGE_HISTORY_ROLES);
